export const en = {
    be: 'Belarusian',
    de: 'German',
    en: 'English',
    kz: 'Kazakh',
    'language-not-set': 'Select a language',
    ru: 'Russian',
    tr: 'Turkish',
    ua: 'Ukrainian',
    uz: 'Uzbek'
};
